import {MsgTree} from '@/vue-dlb/utils/msgtree';
import {Item} from '@/vue-dlb/utils/item';


export class MsgTreeParser {
  constructor() {
    this.currentItemIndex = -1;
    this.preItemLevel = -1;
    this.preItemGroup = '';
    this.msgItems = [];
  }

  _init(msgtbl) {
    this.msgItems = msgtbl;
    this.currentItemIndex = 0;
    this.preItemLevel = 0;
    this.preItemGroup = '0';
  }

  _readCurrentItem() {
    return this.msgItems[this.currentItemIndex];
  }

  _readNextItem() {
    if (this.currentItemIndex === this.msgItems.length - 1) return null;

    this.currentItemIndex += 1;
    return this.msgItems[this.currentItemIndex];
  }
  _goParent(dict) {
    if(!dict.parent) return dict.parent;
    else return dict;
  }

  parse(msgtbl) {
    this._init(msgtbl);
    const result = new MsgTree('ROOT', "ROOT");
    result.opened = false;
    result.disabled = false;
    result.selected = true;
    this._doParse(this._readCurrentItem(), result);
    //console.log('-------RESULT--------');
    //console.log(result.toJson());
    return [result.toJson()];
  }

  _doParse(segitem, dict) {
    if (!segitem) return;
    if (!dict) return;

    if (segitem.GRP_LOOP.trim().length == 0) {
      //console.log('--------- read next -------------');
      this._doParse(this._readNextItem(), dict);
    }
    else{

      // console.log('-------_doParse!!--------');
      // console.log(JSON.stringify(segitem));
      // console.log('----------------------');
      // console.log(dict.toJson());
      // console.log('----------------------');

      if (segitem.GRP_LOOPLVL < this.preItemLevel) // 상위그룹으로 올라가는 경우
      {
        // console.log(segitem.GRP_LOOPLVL + '/' + this.preItemLevel);
        // console.log('---------find parent----------');
        if( (segitem.DATAELEM == '0000') ||
          (segitem.GRP_LOOP >= '1' && segitem.GRP_LOOPLVL == '0' &&
          (segitem.GRP_LOOPID == '0' || segitem.GRP_LOOPID == 'UNH'))){   // 최상위 그룹이 LOOPID가 0인 경우도 있고 UNH로 된 경우도 있음
          // 최상위 그룹으로 바로 올라가는 경우 두번 올라감
          let go_dict = dict;
          //for(var i = 0; i <= (this.preItemLevel - segitem.GRP_LOOPLVL); i++){
          for(var i = segitem.GRP_LOOPLVL; i <= this.preItemLevel; i++){
            //console.log('goParent');
            if(go_dict.parent != undefined) go_dict = go_dict.parent;
            // console.log(go_dict.toJson());
            // console.log('----------------------');
          }
          this.preItemLevel = segitem.GRP_LOOPLVL;
          this.preItemGroup = segitem.GRP_LOOPID;
          this._doParse(this._readCurrentItem(), go_dict);
        } else {
          // 그냥 상위 그룹으로 올라가는 경우
          //console.log('---------go parent----------');
          this.preItemLevel = segitem.GRP_LOOPLVL;
          this.preItemGroup = segitem.GRP_LOOPID;
          this._doParse(this._readCurrentItem(), dict.parent);

        }
      }
      else if (segitem.GRP_LOOPLVL == this.preItemLevel && segitem.GRP_LOOPID != this.preItemGroup &&
        (segitem.GRP_LOOPID != 'UNH' && segitem.GRP_LOOPID != '0'))
      {
        // 최상위 그룹은 아니고 동일 그룹내에서 반복되는 경우
        // console.log(segitem.GRP_LOOPLVL + '/' + this.preItemLevel);
        // console.log('---------go parent!----------');
        this.preItemLevel = segitem.GRP_LOOPLVL;
        this.preItemGroup = segitem.GRP_LOOPID;
        this._doParse(this._readCurrentItem(), dict.parent);
      }
      else {
        // 그룹이 바뀐경우
        this.preItemLevel = segitem.GRP_LOOPLVL;
        this.preItemGroup = segitem.GRP_LOOPID;

        if (segitem.GRP_LOOP >= '1' && segitem.GRP_LOOPLVL == '0' &&
           (segitem.GRP_LOOPID == '0' || segitem.GRP_LOOPID == 'UNH')){
          // 최상위 그룹의 아이템인 경우
          //console.log('---------ADD ROOT LEVEL ITEM----------');
          //const key = segitem.DB_ELEM;
          const key = segitem.DB_ELEM + '_' + segitem.DATAELEM;
          const name = segitem.SEG + ' - ' + segitem.REQUIRE + ' - '  + segitem.GRP_LOOP +  '  ' + segitem.DATANAME;
          const value = segitem.DB_ELEM
          //console.log('key:' + key);
          let item = new Item(key, name, value);
          item.seg = segitem.SEG;
          item.req = segitem.REQUIRE;
          item.loop = segitem.GRP_LOOP;
          item.dataname = segitem.DATANAME;
          if(segitem.USED_YN === 'N') {
            item.disabled = true;
            item.selected = false;
            item.icon = 'fa fa-check icon-state-success';
          }
          else {
            item.disabled = false;
            item.selected = true;
            item.icon = 'fas fa-feather-alt';
          }

          dict.addItem(item, dict.itemCount);

          //let item = new MsgTree(key, dict);
          //dict.addItem(item, dict.itemCount);

          dict.itemCount++;

          this._doParse(this._readNextItem(), dict);
        }
        else if(segitem.GRP_LOOP >= '1' && segitem.DATAELEM == '0000')
        {
          // 그냥 그룹인 경우
          //console.log('---------ADD GROUP MSGTREE----------');
          //const key = segitem.DB_ELEM;
          const key = segitem.DB_ELEM + '_' + segitem.DATAELEM;
          const name = 'Group(' + segitem.GRP + ')_' + segitem.SEG + ' - ' + segitem.REQUIRE + ' - '  + segitem.GRP_LOOP +  '  ' + segitem.DATANAME;
          //const name = segitem.SEG + ' - ' + segitem.REQUIRE + ' - '  + segitem.GRP_LOOP +  '  ' + segitem.DATANAME;
          //const name = segitem.DATANAME  +  '  ' + segitem.SEG + ' - ' + segitem.REQUIRE + ' - '  + segitem.GRP_LOOP;
          //console.log('key:' + key);
          let item = new MsgTree(key, name, dict);
          item.seg = segitem.SEG;
          item.req = segitem.REQUIRE;
          item.loop = segitem.GRP_LOOP;
          item.dataname = segitem.DATANAME;
          if(segitem.USED_YN === 'N') {
            item.disabled = true;
            item.selected = false;
            item.icon = 'fab fa-elementor';
          }
          else {
            item.disabled = false;
            item.selected = true;
            item.opened = true;
            item.icon = 'fas fa-feather-alt';
          }
          dict.addItem(item, dict.itemCount);
          dict.itemCount++;

          item.itemCount = 0;
          this._doParse(this._readNextItem(), item);

        } else if (segitem.GRP_LOOP >= '1' && segitem.DATAELEM == '0001')
        {
          // 그룹내 세그먼트인 경우
          //console.log('---------ADD ITEM TO GROUP ----------');
          //const key = segitem.DB_ELEM;
          const key = segitem.DB_ELEM + '_' + segitem.DATAELEM;
          const name = segitem.SEG + ' - ' + segitem.REQUIRE + ' - '  + segitem.GRP_LOOP +  '  ' + segitem.DATANAME;
          const value = segitem.DB_ELEM
          //console.log('key:' + key);
          //let item = dict.findItem(key);
          //if (!item) {
            let item = new Item(key, name, value);
            item.seg = segitem.SEG;
            item.req = segitem.REQUIRE;
            item.loop = segitem.GRP_LOOP;
            item.dataname = segitem.DATANAME;
            if(segitem.USED_YN === 'N') {
              item.disabled = true;
              item.selected = false;
              item.icon = 'fa fa-check icon-state-success';
            }
            else {
              item.disabled = false;
              item.selected = true;
              item.icon = 'fas fa-feather-alt';
            }

            dict.addItem(item, dict.itemCount);
            dict.itemCount++;
          //}

          this._doParse(this._readNextItem(), dict);
        }
        // else if (segitem.GRP_LOOP >= '1' && segitem.DATAELEM == '0001')
        // {
        //   console.log('---------ADD ITEM TO GROUP ----------');
        //   const key = segitem.SEG;
        //   const value = segitem.DB_ELEM
        //   let item = dict.findItem(key);
        //   if (!item) {
        //     item = new Item(key, value);
        //     dict.addItem(item, dict.itemCount - 1);
        //   }

        //   this._doParse(this._readNextItem(), dict);
        // }
        else {
          //console.log('---------ELSE----------');
          this._doParse(this._readNextItem(), dict);
        }

      }
    }

  }
}

// module.exports = MsgTreeParser;
